import React from 'react';
export const ChristmasDecorations = () => {
  return <>
      {/* Snowflakes */}
      <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden" data-id="element-99">
        {[...Array(30)].map((_, i) => <div key={i} className="absolute text-white opacity-70 animate-snowfall" style={{
        left: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 10}s`,
        animationDuration: `${10 + Math.random() * 10}s`,
        fontSize: `${10 + Math.random() * 10}px`
      }} data-id="element-100">
            ❄
          </div>)}
      </div>

      {/* Christmas Lights Border - Top */}
      <div className="fixed top-0 left-0 right-0 h-8 pointer-events-none z-40 flex justify-around items-center" data-id="element-101">
        {[...Array(20)].map((_, i) => <div key={i} className="w-3 h-3 rounded-full animate-twinkle" style={{
        backgroundColor: ['#C41E3A', '#165B33', '#FFD700', '#00C3FF'][i % 4],
        animationDelay: `${i * 0.2}s`,
        boxShadow: `0 0 10px ${['#C41E3A', '#165B33', '#FFD700', '#00C3FF'][i % 4]}`
      }} data-id="element-102" />)}
      </div>

      {/* Hanging Ornaments */}
      <div className="fixed top-8 left-0 right-0 pointer-events-none z-40 flex justify-around" data-id="element-103">
        {[...Array(8)].map((_, i) => <div key={i} className="flex flex-col items-center animate-float" style={{
        animationDelay: `${i * 0.3}s`
      }} data-id="element-104">
            <div className="w-0.5 h-4 bg-christmas-silver opacity-50" data-id="element-105" />
            <div className="w-6 h-6 rounded-full shadow-christmas-glow" style={{
          backgroundColor: ['#C41E3A', '#165B33', '#FFD700'][i % 3],
          boxShadow: `0 0 15px ${['#C41E3A', '#165B33', '#FFD700'][i % 3]}`
        }} data-id="element-106" />
          </div>)}
      </div>
    </>;
};